import { useNavigate, useParams } from "react-router-dom";
import DetailRow from "../../general/DetailRow";
import IMAGES from "../../../constant/images";
import Loader from "../../Loader";
import useFetchStudentInfo from "../../../api/classes/students/useFetchStudentInfo";
import FormButton from "../../form/FormButton";

const StudentDetails = ({ studentId, closeSideModal, type }) => {
  const { classId, schoolId } = useParams();
  const navigate = useNavigate();

  const [details, loading] = useFetchStudentInfo(studentId, "basic");
  const [guardian] = useFetchStudentInfo(studentId, "guardian");

  function handleEdit() {
    navigate(`/${schoolId}/classes/${classId}/student/${studentId}?type=basic`);
  }

  if (!studentId || type !== "details") return null;

  if (loading) return <Loader loading={loading} />;

  return (
    <div className="h-full flex flex-col">
      <div className="w-full">
        <img
          src={IMAGES.studentAvatar}
          alt=""
          className="w-full object-cover"
        />
      </div>

      <div className="flex-1 flex flex-col">
        <div className="py-3 px-3">
          <h3 className="font-bold text-yankee_blue mb-3 text-lg capitalize">
            {details?.lastName || ""} {details?.firstName || ""}
          </h3>

          <DetailRow label={"Email address"} value={details?.email || "N/A"} />
          <DetailRow label={"Contact"} value={details?.phone || "N/A"} />
          <DetailRow label={"Address"} value={details?.address || "N/A"} />
          <DetailRow label={"Religion"} value={details?.religion || "N/A"} />
        </div>

        <div className="py-3 px-3">
          <h3 className="font-bold text-yankee_blue mb-3 text-lg">
            Guardian Information
          </h3>

          <DetailRow
            label={"Name"}
            value={`Mr & Mrs ${guardian?.name || "N/A"}`}
          />
          <DetailRow label={"Email address"} value={guardian?.email || "N/A"} />
          <DetailRow label={"Contact"} value={guardian?.phone || "N/A"} />
          <DetailRow label={"Address"} value={guardian?.address || "N/A"} />
          <DetailRow
            label={"Occupation"}
            value={guardian?.occupation || "N/A"}
          />
        </div>

        <div className="py-3 px-3">
          <h3 className="font-bold text-yankee_blue mb-3 text-lg">
            Medical Information
          </h3>

          <div className="grid grid-cols-2">
            <DetailRow label={"Weight"} value={details?.weight || "N/A"} />
            <DetailRow label={"Height"} value={details?.height || "N/A"} />
          </div>

          <div className="grid grid-cols-2">
            <DetailRow
              label={"Blood group"}
              value={details?.bloodType || "N/A"}
            />
            <DetailRow label={"Genotype"} value={details?.genoType || "N/A"} />
          </div>
        </div>

        {/* buttons */}
        <div className="py-3 px-3 mt-auto">
          <FormButton
            title={"Edit details"}
            onClick={() => handleEdit(studentId)}
          />

          <button
            className="bg-transparent text-coral_red h-10 w-full rounded-md text-sm font-semibold"
            onClick={closeSideModal}
          >
            Back to list
          </button>
        </div>
      </div>
    </div>
  );
};
export default StudentDetails;
